import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
// import { closeDrawer } from "./store/actions";
import styles from "./drawer-modal.module.scss";
import { RootState } from "@src/reducers/store";
import { updateModalsCloseDrawerModal } from "@src/reducers/your-reducer";
import closeIconWhite from "@src/assets/svg/close-icon-white.svg";
import cn from "classnames";
import { useI18N } from "@src/language/language-context";

interface DrawerModalProps {
  id: string;
  children: React.ReactNode;
  onClose?: () => void;
}

const cssClassName = "drawer-modal";

export const DrawerModal: React.FC<DrawerModalProps> = ({
  id,
  children,
  onClose,
}) => {
  const i18n = useI18N();
  const texts = {
    close: i18n("modules.drawerModal.close"),
  };

  const dispatch = useDispatch();
  // const drawerState = useSelector((state: any) => state.drawer[id]);
  const drawerState = useSelector(
    (state: RootState) => state.yourSlice.modals[id],
  );

  const drawerRef = useRef<HTMLDivElement>(null);

  // Handle focus management when drawer is open
  useEffect(() => {
    if (drawerState?.showModal) {
      drawerRef.current?.focus();
    }
  }, [drawerState?.showModal]);

  const closeDrawerModal = () => {
    dispatch(updateModalsCloseDrawerModal({ showModal: false, id: id }));
    onClose?.();
  };

  if (!drawerState) return null; // Return nothing if drawer state for this ID does not exist

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    <div
      className={cn(styles[`${cssClassName}__backdrop`], {
        [styles[`${cssClassName}__backdrop--open`]]: drawerState.showModal,
      })}
      aria-hidden={!drawerState.showModal}
    >
      <div
        className={cn(
          styles[`${cssClassName}__content`],
          styles[`${cssClassName}__content--${drawerState.placement}`],
        )}
        style={{
          width:
            drawerState.placement === "left" ||
            drawerState.placement === "right"
              ? drawerState.size
              : "100%",
          height:
            drawerState.placement === "top" ||
            drawerState.placement === "bottom"
              ? drawerState.size
              : "100%",
        }}
        tabIndex={-1}
        ref={drawerRef}
        role="dialog"
        aria-modal="true"
      >
        <button
          className={styles[`${cssClassName}__close-btn`]}
          onClick={closeDrawerModal}
        >
          <img src={closeIconWhite} alt={texts.close} />
        </button>
        {children}
      </div>
    </div>
  );
};
